import dynamic from 'next/dynamic'

import { useStaticData } from '@mc/static-data-react'
import { TRACK_CONTENT_TYPES } from '@mc/track-event'
import CTA from 'components/CTA'

import { useEpisodeVideoModal } from './EpisodeListVideoContext'
import { EpisodeStaticData } from '../../[episodeSlug].page'

const VideoModal = dynamic(() => import('components/VideoModal'), {
  ssr: false,
})

export const EpisodeVideoModal = () => {
  const { showVideoModal, selectedEpisode, onClose } = useEpisodeVideoModal()
  const { course, episode } = useStaticData<EpisodeStaticData>()

  const contentId = `${course.id}_${
    selectedEpisode?.teaser?.brightcoveVideoId ??
    selectedEpisode?.teaser?.mediaUuid
  }`

  return (
    <VideoModal
      show={showVideoModal}
      onCloseModal={onClose}
      videoId={selectedEpisode?.teaser?.brightcoveVideoId}
      mediaUuid={selectedEpisode?.teaser?.mediaUuid}
      isSample
      courseId={course.id}
      author={selectedEpisode?.title ?? undefined}
      contentId={contentId}
      contentTitle={selectedEpisode?.title ?? ''}
      contentType={TRACK_CONTENT_TYPES.EPISODE_GEM}
      tagline={selectedEpisode?.instructors
        ?.map((instructor) => instructor.name)
        .join(', ')}
      instructorAvatar={
        selectedEpisode?.instructors?.[0]?.headshotUrl ?? undefined
      }
      buttonGroup={
        <CTA
          trackProps={{
            category: 'other-episodes',
            class: course.slug,
            episode: episode.title,
            content_type: 'product',
            location: 'episode_gem_modal_header',
            page_category: 'personalization',
          }}
        />
      }
    />
  )
}
